import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Iphone 13",
    description: "Apple Iphone 13 256GB",
    categoryName: "smartphone",
    brand: "apple",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/smartphone/iphone.jpg",
    imgAlt: "iphone 13",
    price: 89000,
    discount: 10,
    discountPrice: 80100,
    inStock: true,
    rating: 4,
    allRating: 692,
  },
  {
    _id: uuid(),
    title: "One Plus Nord 2",
    description: "One Plus Nord 2 128GB",
    categoryName: "smartphone",
    brand: "one plus",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/smartphone/oneplus.jpg",
    imgAlt: "oneplus nord",
    price: 25000,
    discount: 15,
    discountPrice: 21250,
    inStock: true,
    rating: 3,
    allRating: 259,
  },
  {
    _id: uuid(),
    title: "Samsung S20 FE",
    description: "Samsung S20 FE 256GB",
    categoryName: "smartphone",
    brand: "samsung",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/smartphone/samsung.jpg",
    imgAlt: "samsung s20",
    price: 59000,
    discount: 10,
    discountPrice: 53100,
    inStock: true,
    rating: 4,
    allRating: 69,
  },
  {
    _id: uuid(),
    title: "Redmi Note 11T",
    description: "Redmi Note 11T 256 GB",
    categoryName: "smartphone",
    brand: "redmi",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/smartphone/xiaomi.jpg",
    imgAlt: "redmi note11",
    price: 14900,
    discount: 10,
    discountPrice: 13410,
    inStock: true,
    rating: 3,
    allRating: 726,
  },
  // Laptop
  {
    _id: uuid(),
    title: "MacBook Air M1",
    description: "MacBook 8GB RAM, 256GB SSD",
    categoryName: "laptop",
    brand: "apple",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/laptop/Apple%20MacBook%20Air%20M1.jpg",
    imgAlt: "apple macbook air ",
    price: 83000,
    discount: 10,
    discountPrice: 74700,
    inStock: true,
    rating: 5,
    allRating: 69,
  },
  {
    _id: uuid(),
    title: "Asus E410KA-EK001W",
    description: "Asus 4GB RAM, 256GB SSD",
    categoryName: "laptop",
    brand: "asus",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/laptop/Asus%20E410KA-EK001W.jpg",
    imgAlt: "asus E410KA",
    price: 27000,
    discount: 5,
    discountPrice: 25650,
    inStock: true,
    rating: 3,
    allRating: 469,
  },
  {
    _id: uuid(),
    title: "HP Pavilion 14",
    description: "HP dv1000TU 8GB RAM",
    categoryName: "laptop",
    brand: "hp",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/laptop/HP%20Pavilion%2014-dv1000TU.jpg",
    imgAlt: "hp Pavilion",
    price: 61900,
    discount: 10,
    discountPrice: 55710,
    inStock: true,
    rating: 4,
    allRating: 36,
  },
  {
    _id: uuid(),
    title: "Lenovo Legion 5",
    description: "16GB RAM, 1TB SSD RTX 3060",
    categoryName: "laptop",
    brand: "lenovo",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/laptop/Lenovo%20Legion%205.jpg",
    imgAlt: "lenovo lenovo",
    price: 81000,
    discount: 10,
    discountPrice: 72900,
    inStock: true,
    rating: 4,
    allRating: 254,
  },
  // Camera
  {
    _id: uuid(),
    title: "Nikon D780",
    description: "Nikon25.28 MP DSLR Camera",
    categoryName: "camera",
    brand: "Nikon",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/camera/Nikon%20D780.jpg",
    imgAlt: "nikon camera",
    price: 45000,
    discount: 5,
    discountPrice: 42750,
    inStock: true,
    rating: 4,
    allRating: 459,
  },
  {
    _id: uuid(),
    title: "Fujifilm Mirrorless",
    description: "Fujifilm  24.2MP 15-45mm Lens",
    categoryName: "camera",
    brand: "Fujifilm",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/camera/Fujifilm%2024.2MP.jpg",
    imgAlt: "fujifilm camera",
    price: 59000,
    discount: 15,
    discountPrice: 50150,
    inStock: true,
    rating: 2,
    allRating: 956,
  },
  {
    _id: uuid(),
    title: "Canon EOS 1500D",
    description: "24.1MP DSLR Camera",
    categoryName: "camera",
    brand: "canon",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/camera/Canon%20EOS.jpg",
    imgAlt: "canon camera",
    price: 37995,
    discount: 15,
    discountPrice: 32295,
    inStock: true,
    rating: 4,
    allRating: 422,
  },

  // Headphones
  {
    _id: uuid(),
    title: "Dell AE2",
    description: "USB Wired Gaming Headphones",
    categoryName: "headphones",
    brand: "dell",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/headphones/Dell%20AE2%20USB%20Wired%20Gaming%20Headphones.png",
    imgAlt: "dell headphone",
    price: 3490,
    discount: 10,
    discountPrice: 3141,
    inStock: false,
    rating: 1,
    allRating: 26,
  },
  {
    _id: uuid(),
    title: "JBL Tune 500",
    description: "Wired Headphone",
    categoryName: "headphones",
    brand: "jbl",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/headphones/JBL%20Tune%20500%20Wired%20Headphone.png",
    imgAlt: " headphone",
    price: 1800,
    discount: 10,
    discountPrice: 1620,
    inStock: true,
    rating: 4,
    allRating: 726,
  },
  {
    _id: uuid(),
    title: "Sony MDR-ZX110",
    description: "Passive Noise Cancellation",
    categoryName: "headphones",
    brand: "sony",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/headphones/Sony%20Headphone%20MDR-ZX110.png",
    imgAlt: "sony headphone",
    price: 2400,
    discount: 10,
    discountPrice: 2160,
    inStock: true,
    rating: 3,
    allRating: 269,
  },
  {
    _id: uuid(),
    title: "Sony MDR-XB450AP",
    description: "Extra Bass headphones",
    categoryName: "headphones",
    brand: "",
    imgURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/ecommerce/productIMG/headphones/Sony%20MDR-XB450AP%20Extra%20Bass.png",
    imgAlt: " headphone",
    price: 1900,
    discount: 10,
    discountPrice: 1710,
    inStock: true,
    rating: 5,
    allRating: 669,
  },
];
